var map = {
	"./bootstrap-logo.svg": 5920,
	"./cpp-logo.svg": 4767,
	"./css-logo.svg": 4337,
	"./html-logo.svg": 2675,
	"./java-logo.svg": 5198,
	"./javascript-logo.svg": 673,
	"./mysql-logo.svg": 7872,
	"./openai-logo.svg": 1536,
	"./postgresql-logo.svg": 5824,
	"./python-logo.svg": 5020,
	"./react-logo.svg": 6037,
	"./solidity-logo.svg": 8223,
	"./spring-logo.svg": 7411,
	"./sqlite-logo.svg": 6798,
	"./typescript-logo.svg": 1
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1894;